import { Injectable } from '@angular/core';
import axios from 'axios';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PedidosServiceService {

  constructor() { }

  public async getPedidos(id:string) {
    const response = await axios.get(`${environment.apiUrl}/ventas/autoservice/free/display`,{
      headers:{
        idpuntodeventa:id.replace(/\//g, '')
      }
    })
    return response.data
  }
}
